export default __webpack_public_path__ + "static/petals_of_gold-ddf31067ccd17cf086a0b74bd96688d4.png";